'use strict';

var _toConsumableArray = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");
var _classCallCheck = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var Ref = require('./ref');
var internals = {};
internals.extendedCheckForValue = function (value, insensitive) {
  var valueType = typeof value;
  if (valueType === 'object') {
    if (value instanceof Date) {
      return function (item) {
        return item instanceof Date && value.getTime() === item.getTime();
      };
    }
    if (Buffer.isBuffer(value)) {
      return function (item) {
        return Buffer.isBuffer(item) && value.length === item.length && value.toString('binary') === item.toString('binary');
      };
    }
  } else if (insensitive && valueType === 'string') {
    var lowercaseValue = value.toLowerCase();
    return function (item) {
      return typeof item === 'string' && lowercaseValue === item.toLowerCase();
    };
  }
  return null;
};
module.exports = /*#__PURE__*/function () {
  function InternalSet(from) {
    _classCallCheck(this, InternalSet);
    this._set = new Set(from);
    this._hasRef = false;
  }
  _createClass(InternalSet, [{
    key: "add",
    value: function add(value, refs) {
      var isRef = Ref.isRef(value);
      if (!isRef && this.has(value, null, null, false)) {
        return this;
      }
      if (refs !== undefined) {
        // If it's a merge, we don't have any refs
        Ref.push(refs, value);
      }
      this._set.add(value);
      this._hasRef |= isRef;
      return this;
    }
  }, {
    key: "merge",
    value: function merge(add, remove) {
      var _iterator = _createForOfIteratorHelper(add._set),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;
          this.add(item);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      var _iterator2 = _createForOfIteratorHelper(remove._set),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _item = _step2.value;
          this.remove(_item);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      return this;
    }
  }, {
    key: "remove",
    value: function remove(value) {
      this._set.delete(value);
      return this;
    }
  }, {
    key: "has",
    value: function has(value, state, options, insensitive) {
      return !!this.get(value, state, options, insensitive);
    }
  }, {
    key: "get",
    value: function get(value, state, options, insensitive) {
      if (!this._set.size) {
        return false;
      }
      var hasValue = this._set.has(value);
      if (hasValue) {
        return {
          value: value
        };
      }
      var extendedCheck = internals.extendedCheckForValue(value, insensitive);
      if (!extendedCheck) {
        if (state && this._hasRef) {
          var _iterator3 = _createForOfIteratorHelper(this._set),
            _step3;
          try {
            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              var item = _step3.value;
              if (Ref.isRef(item)) {
                item = [].concat(item(state.reference || state.parent, options));
                var found = item.indexOf(value);
                if (found >= 0) {
                  return {
                    value: item[found]
                  };
                }
              }
            }
          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }
        }
        return false;
      }
      return this._has(value, state, options, extendedCheck);
    }
  }, {
    key: "_has",
    value: function _has(value, state, options, check) {
      var checkRef = !!(state && this._hasRef);
      var isReallyEqual = function isReallyEqual(item) {
        if (value === item) {
          return true;
        }
        return check(item);
      };
      var _iterator4 = _createForOfIteratorHelper(this._set),
        _step4;
      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var item = _step4.value;
          if (checkRef && Ref.isRef(item)) {
            // Only resolve references if there is a state, otherwise it's a merge
            item = item(state.reference || state.parent, options);
            if (Array.isArray(item)) {
              var found = item.findIndex(isReallyEqual);
              if (found >= 0) {
                return {
                  value: item[found]
                };
              }
              continue;
            }
          }
          if (isReallyEqual(item)) {
            return {
              value: item
            };
          }
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
      return false;
    }
  }, {
    key: "values",
    value: function values(options) {
      if (options && options.stripUndefined) {
        var values = [];
        var _iterator5 = _createForOfIteratorHelper(this._set),
          _step5;
        try {
          for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
            var item = _step5.value;
            if (item !== undefined) {
              values.push(item);
            }
          }
        } catch (err) {
          _iterator5.e(err);
        } finally {
          _iterator5.f();
        }
        return values;
      }
      return Array.from(this._set);
    }
  }, {
    key: "slice",
    value: function slice() {
      var set = new InternalSet(this._set);
      set._hasRef = this._hasRef;
      return set;
    }
  }, {
    key: "concat",
    value: function concat(source) {
      var set = new InternalSet([].concat(_toConsumableArray(this._set), _toConsumableArray(source._set)));
      set._hasRef = !!(this._hasRef | source._hasRef);
      return set;
    }
  }]);
  return InternalSet;
}();